export function SettingsPage() {
  return (
    <div className="max-w-3xl">
      <h2 className="text-3xl font-bold mb-2">Settings</h2>
      <p className="text-parchment-700 mb-8">
        Read-only view of current channel config. Edit-in-place ships as a
        follow-up — for now, edits go through Secrets Manager / Lambda env vars.
      </p>

      <div className="space-y-4">
        <div className="card-neumorphic">
          <h3 className="font-heading font-semibold mb-2">Channel</h3>
          <p className="text-sm font-mono text-parchment-700">
            Enneking Media Studio · Channel #1
          </p>
          <p className="text-xs font-mono text-parchment-700 mt-2">
            Tone default: authoritative explainer, slightly contrarian, no jargon without explanation
          </p>
        </div>

        <div className="card-neumorphic">
          <h3 className="font-heading font-semibold mb-2">Voice</h3>
          <p className="text-sm font-mono text-parchment-700">
            ElevenLabs v3 · stability 0.6 · similarity 0.85 · style 0.3
          </p>
          <p className="text-xs font-mono text-parchment-700 mt-2">
            Voice id stored at <code>ems/elevenlabs-voice-id-channel-1</code>.
            Swap by updating that secret.
          </p>
        </div>

        <div className="card-neumorphic">
          <h3 className="font-heading font-semibold mb-2">Disney Safety Blacklist</h3>
          <p className="text-sm font-mono text-parchment-700">
            entertainment · streaming · scripted · animation · Disney · Marvel ·
            Lucasfilm · Hulu · FX · ABC · ESPN · NatGeo · Pixar
          </p>
          <p className="text-xs font-mono text-parchment-700 mt-2">
            Enforced non-bypassably by <code>ems-topic-safety-check</code> Lambda.
            Per project rules: if a topic ever blocks unfairly, refactor the
            wording in the handler — do not remove the rule.
          </p>
        </div>

        <div className="card-neumorphic">
          <h3 className="font-heading font-semibold mb-2">Cost Caps</h3>
          <p className="text-sm font-mono text-parchment-700">
            per-video: $40 target / $50 hard cap · daily: $100
          </p>
          <p className="text-xs font-mono text-parchment-700 mt-2">
            Hard cap enforced by <code>ems-broll-worker</code> circuit breaker.
          </p>
        </div>

        <div className="card-neumorphic">
          <h3 className="font-heading font-semibold mb-2">Creatomate</h3>
          <p className="text-sm font-mono text-parchment-700">
            source-based assembly (no saved template)
          </p>
          <p className="text-xs font-mono text-parchment-700 mt-2">
            <code>video-assembler.ts</code> builds the full RenderScript JSON
            inline from script + asset keys + script-defined timestamps. No UI
            template to maintain. Webhook URL is dynamic per-render with
            secret-in-path verification.
          </p>
        </div>

        <div className="card-neumorphic">
          <h3 className="font-heading font-semibold mb-2">YouTube</h3>
          <p className="text-sm font-mono text-parchment-700">
            Channel: Enneking Media Studio (Channel #1)
          </p>
          <p className="text-xs font-mono text-parchment-700 mt-2">
            OAuth refresh token at <code>ems/youtube-refresh-token-channel-1</code>.
            AI disclosure flag always set (containsSyntheticMedia=true).
          </p>
        </div>
      </div>
    </div>
  );
}
